import React from 'react';

export const BRAND_WORDMARK_LABEL = 'Redacto';

function BrandWordmark({ className = '', title = BRAND_WORDMARK_LABEL, ariaLabel = BRAND_WORDMARK_LABEL }) {
  return (
    <span className={className} title={title} aria-label={ariaLabel} role="img">
      <span className="brand-wordmark-visual" aria-hidden="true">
        <span className="brand-wordmark-text">Redact</span>
        <span className="brand-wordmark-glyph" />
      </span>
      <span className="sr-only">{BRAND_WORDMARK_LABEL}</span>
    </span>
  );
}

export default BrandWordmark;
